export default function briefAddUploadAction(context, payload, done) {
    context.dispatch('BRIEF_ADD_UPLOAD', payload);
    return done();
}



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/brief-add-upload.jsx